// Builds a CSV file from an array of rows and triggers a browser download.
// A UTF-8 BOM is prepended so Excel renders Arabic names correctly.

const escapeCell = (value: any) => {
  if (value === null || value === undefined) {
    return '""';
  }
  return '"' + String(value).replace(/"/g, '""') + '"';
};

export const downloadCsv = (
  filename: string,
  headers: string[],
  rows: any[][]
) => {
  const csv = [headers, ...rows]
    .map((row) => row.map(escapeCell).join(','))
    .join('\r\n');

  const blob = new Blob(['﻿' + csv], {
    type: 'text/csv;charset=utf-8;',
  });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};

// Google maps link built from the coordinates stored as location_lat / location_lng
export const mapsLink = (lat: any, lng: any) => {
  if (!lat || !lng) {
    return '';
  }
  return `https://www.google.com/maps/search/?api=1&query=${lat},${lng}`;
};
